// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3WKnU","bigColWidth":"Table_bigColWidth__3s06F","biggerColWidth":"Table_biggerColWidth__3tsK6","row":"Table_row__3pmPv","col":"Table_col__3pz7_"};